<template>
    <div>
        <div style="height:60%;display:grid; place-items: center;">
            <div style="text-align:center;">
                <img :src="require('@/assets/member_regist_complete.png')" style="width:170px; height:170px;">
                <div style="margin-top:-30px; font-size:22px; font-weight:bold;">환불 접수가 완료됐어요!</div>
                <div style="margin-top:18px; color:#737373;">계좌를 등록해주세요.</div>
            </div>
        </div>
        <div style="flex:1; ">

        </div>
        <div style="text-align: center;">
            <div style="font-size:12px; color:#656565;">"환불 금액은 등록하신 계좌로 입금됩니다."</div>
            <div style="font-size:14px; margin-top:20px; text-decoration: underline; color:#656565; font-weight:bold;" @click="showBankAccountForm">계좌번호 등록/수정</div>
            <div style="height:20px;"></div>
        </div>
        <div style="height:50px; display:grid; place-items: center; background-color: #ff6100; font-weight:bold; color:white;" @click="close" >확인</div>
    </div>
</template>

<script>
    export default {
        name: "RefundComplete",
        methods : {
            close(){
                this.$GlobalStore.closeLastModal();
            },
            showBankAccountForm(){
                this.$GlobalStore.closeLastModal();
                this.$GlobalStore.addModal('BankAccountForm', {transitionName : ''});
            }
        }
    }
</script>

<style scoped>

</style>